export enum GizmoViewOrientation {
  Top, Left, Right, Front, Bottom, Back
}

export interface IViewSettings {
  upperJawVisible: boolean;
  lowerJawVisible: boolean;
  attachments: boolean;
  pontics: boolean;
  iprs: boolean;
  elastics: boolean;
  biteRamps: boolean;
  translateBlocks: boolean;
  grid: boolean;
  overlay: boolean;
  gridSize: number;
  occlusions: boolean;
  hideGum: boolean;
  showCbctJaws: boolean;
  teethLikeSemitransparent: { upperJaw: boolean, lowerJaw: boolean };
}
